<template>
  <div class="sm_star">
    <!-- header -->
    <!-- <div class="sm_header">
			<h1>Samsung STAR</h1>
			<button class="menu_btn"><span>mobile menu</span></button>
		</div> -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="goBackPreviousPage"
      :rightBtnMethod="rightBtnMethod"
      ref="top_app_bar"
    >
    </TopAppBar>
    <!-- //header -->

    <!-- content -->
    <div
      class="d-flex flex-column t-center"
      style="background-color: #2d6dcc; height: 100vh"
      v-if="!file"
    >
      <img src="/images/01_Samsung_logo.png" style="margin-top: 40%" />
    </div>

    <div class="sm_content" style="width: 100%; padding-top: 54px" v-if="file">
      <pinch-zoom limitPan="true" minScale="1" limitZoom="4">
        <img
          v-if="getType(file.contentType) === 'image'"
          :src="file.resourceUri"
          :alt="file.originalName"
        />
      </pinch-zoom>

      <video-player
        class="video-player-box"
        v-if="getType(file.contentType) === 'video'"
        ref="videoPlayer"
        :options="getPayerOption(file)"
        :playsinline="true"
      />
    </div>
    <!-- //content -->
  </div>
</template>

<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
export default {
  components: {
    videoPlayer,
    TopAppBar,
  },
  data() {
    return {
      file: null,
    };
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.setTopAppBarCloseSocialPopup("");
    this.file = JSON.parse(localStorage.getItem("socialFile"));
    console.log("I amgatting============", this.file);
  },

  methods: {
    goBackPreviousPage() {
      this.$router.push(
        "/socialLearning/" +
          this.$route.query.postId +
          "?bId=" +
          this.$route.query.bId +
          "&a=1"
      );
    },

    getType(contentType) {
      return contentType.split("/")[0];
    },
    getPayerOption(img) {
      //alert($(window).width())
      return {
        //muted: true,
        language: "en",
        controls: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            type: img.contentType,
            src: img.resourceUri,
          },
        ],
        height: $(window).height() - 100,
        width: $(window).width() - 10,
      };
    },
  },
};
</script>
<style >
.video-js .vjs-big-play-button {
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%);
  width: 80px !important;
  height: 80px !important;
  -webkit-border-radius: 0.8em !important;
  -moz-border-radius: 0.8em !important;
  border-radius: 1.9em !important;
  font-size: 5em !important;
}
</style>